// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".element_holder_sunbit{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:reverse;-ms-flex-direction:row-reverse;flex-direction:row-reverse;width:26.5rem}.element_label{width:26%;height:120px;float:left}.element_label label{margin-top:11px;margin-bottom:10px}#payment-element{width:71%}label[for=save_card]{margin-top:1px}", ""]);
// Exports
module.exports = exports;
